import React, { useEffect, useState } from "react";
import Header from "../../../common/header/header";
import {
  baseUrl,
  share_social_icon,
  facebooksocialicon,
  twittersocialicon,
  instagramsocialicon,
  linkedin_social_icon,
} from "../../../api/baseUrl";
import { useLocation } from "react-router-dom";
import { useDisclosure } from "@mantine/hooks";
import { useCookies } from "react-cookie";
import { DatePickerInput } from "@mantine/dates";
import { Button, Modal, TextInput } from "@mantine/core";
import LoadingImage from "../../../assets/media/loader.gif";
import Nav from "../../media/nav";
import { IconSearch, IconCalendar } from "@tabler/icons-react";
import { Link } from "react-router-dom";

function AnalystBriefing() {
  const location = useLocation();
  let compId = location.state !== undefined ? location.state.id : 189;
  const [currentPrice, setCurrentPrice] = useState({});
  const [result, setResult] = useState([]);
  const [is, setIs] = useState([]);
  const [cookies] = useCookies();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [companyId, setCompanyId] = useState(compId);
  const [company, setCompany] = useState({});
  const [inputValue, setInputValue] = useState("");
  const [dateValue, setDateValue] = useState();
  const [visibleItems, setVisibleItems] = useState(10);
  // const [mediaopened, { open, close }] = useDisclosure(false);
  const [modelActive, setModelActive] = useState("");
  const [mediaopened, setMediaOpened] = useState(false);
  const [opened, setOpened] = useState(false);
  const [isCopying, setIsCopying] = useState(false);
  const [currentVideo, setCurrentVideo] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const { pathname } = useLocation();
  const close = () => setMediaOpened(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  const loadMoreItems = () => {
    setVisibleItems((prev) => prev + 4);
  };

  const [url, setUrl] = useState(`${baseUrl}/media/analystbriefing`);

  useEffect(() => {
    setIsLoading(true);
    fetch(url, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${cookies?.accessToken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setResult(data);
        setFilteredData(data);
        setIsLoading(false);
      });
  }, [url]);

  const handleSearch = () => {
    setIsLoading(true);

    let filtered = result;

    if (searchInput.trim() !== "") {
      filtered = filtered.filter((item) =>
        item.title.toLowerCase().includes(searchInput.toLowerCase())
      );
    }
    if (dateValue && dateValue[0] && dateValue[1]) {
      const sd_time = new Date(dateValue[0]).getTime();
      const ed_time = new Date(dateValue[1]).getTime();

      filtered = filtered.filter((item) => {
        const itemDate = new Date(item.date).getTime();
        return itemDate >= sd_time && itemDate <= ed_time;
      });
    }

    setTimeout(() => {
      setFilteredData(filtered);
      setIsLoading(false);
    }, 500);
  };

  const handleCopyUrl = async (url) => {
    try {
      setIsCopying(true);
      await navigator.clipboard.writeText(url);
      setTimeout(() => setIsCopying(false), 1000);
    } catch (error) {
      console.error("Copy failed:", error);
      setIsCopying(false);
    }
  };

  const resetInputField = () => {
    setSearchInput("");
    setDateValue([null, null]);
    setFilteredData(result);
    setVisibleItems(10);
  };

  const handleOpenModal = (videoUrl) => {
    setCurrentVideo(videoUrl);
    setOpened(true);
  };

  return (
    <>
      <Header />
      <div className="result-main analyst">
        <div className="container container_box">
          <Nav companyId={companyId} />
          <div className="media-section">
            <div
              className="row resultboxed latest-boxed corporate-briefing-box"
              style={styles.companyname}
            >
              <TextInput
                value={searchInput}
                onChange={(event) => setSearchInput(event.currentTarget.value)}
                searchable
                placeholder="Search..."
                rightSection={<IconSearch size="1rem" />}
                rightSectionWidth={30}
                styles={{ rightSection: { pointerEvents: "none" } }}
              />
              <DatePickerInput
                clearable
                type="range"
                placeholder="Pick dates range"
                // value={dateValue}
                value={dateValue}
                // onChange={setDateValue}
                onChange={setDateValue}
                icon={<IconCalendar size="1.1rem" stroke={1.5} />}
              />
              <div className="search-clear-button">
                <Button className="search-btn-stle" onClick={handleSearch}>
                  Search
                </Button>
                <Button
                  onClick={resetInputField}
                  className="search-btn-stle clear-btn-stl"
                >
                  Clear
                </Button>
              </div>
            </div>
          </div>
          {isLoading ? (
            <div className="main-loader d-flex flex-column justify-content-center align-items-center">
              <img
                src={LoadingImage}
                alt="Loading..."
                style={{ height: "500px" }}
              />
            </div>
          ) : (
            <div className="main_rearch">
              <div>
                <div className="row">
                  <div className="col-md-12 col-xl-12">
                    <div className="res_sec mt-4 corporate-boxes">
                      <div className="row">
                        {filteredData
                          .slice(0, visibleItems)
                          .map((item, index) => (
                            <div
                              className="col-lg-3 col-md-4 col-sm-6 mb-3"
                              key={index}
                            >
                              <div className="items_box">
                                <Link
                                  to={{
                                    pathname: `/media/analystbriefing/${item.title
                                      .toLowerCase()
                                      .replace(/\s+/g, "-")
                                      .replace(/[^a-z0-9-]/g, "")}`,
                                    state: { item: item },
                                  }}
                                >
                                  <img
                                    src={item.thumbnail}
                                    alt=""
                                    className="luckbox1_img thumnail-image"
                                    style={{ cursor: "pointer" }}
                                  />
                                </Link>
                                <div className="card-body p-0 media-brefing-video">
                                  <h5 className="luckheldtext p-0">
                                    <Link
                                      to={{
                                        pathname: `/media/analystbriefing/${item.title
                                          .toLowerCase()
                                          .replace(/\s+/g, "-")
                                          .replace(/[^a-z0-9-]/g, "")}`,
                                        state: { item: item },
                                      }}
                                    >
                                      {item.title}
                                    </Link>
                                    {/* {item.title} */}
                                  </h5>
                                  <ul className="corporate-underlist">
                                    <li>{item.date2}</li>
                                    <div
                                      onClick={() => {
                                        setModelActive(item);
                                        setMediaOpened(true);
                                      }}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: share_social_icon,
                                        }}
                                      />
                                    </div>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>
                      {filteredData.length === 0 ? (
                        <div className="no-records-found text-center mt-4">
                          <h5>No Record Found</h5>
                        </div>
                      ) : (
                        <>
                          {filteredData.length > 10 &&
                            visibleItems < filteredData.length && (
                              <Button
                                onClick={loadMoreItems}
                                className="mt-3 mb-3 analyst-media-btn"
                              >
                                Load More
                              </Button>
                            )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <Modal
        opened={mediaopened}
        onClose={close}
        title="Share With"
        centered
        size="30rem"
        padding="md"
        classNames={{ header: "text-center" }}
      >
        {/* Your Modal Content */}
        <div className="social-icons text-center space-y-2">
          <a
            href={`http://www.facebook.com/sharer/sharer.php?u=${modelActive.url}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div
              className="social-txt-head"
              dangerouslySetInnerHTML={{
                __html: facebooksocialicon,
              }}
            />
            Facebook
          </a>
          <a
            href={`https://twitter.com/intent/tweet?url=${modelActive.url}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div
              className="social-txt-head"
              dangerouslySetInnerHTML={{
                __html: twittersocialicon,
              }}
            />
            Twitter
          </a>
          <a
            href={`https://www.instagram.com/?url=${modelActive.url}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div
              className="social-txt-head"
              dangerouslySetInnerHTML={{
                __html: instagramsocialicon,
              }}
            />
            Instagram
          </a>
          <a
            href={`https://www.linkedin.com/shareArticle?mini=true&url=${modelActive.url}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div
              className="social-txt-head"
              dangerouslySetInnerHTML={{
                __html: linkedin_social_icon,
              }}
            />
            LinkedIn
          </a>
        </div>
        <div class="share-link-txt">
          <h1>Or share with link</h1>
        </div>
        <div className="field">
          <input type="text" readOnly value={modelActive.url} />
          <Button onClick={() => handleCopyUrl(modelActive.url)}>
            {isCopying ? "Copied..." : "Copy"}
          </Button>
        </div>
      </Modal>

      {/* Modal for video playback */}
      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        size="auto"
        centered
      >
        <iframe
          className="media-ifrme-respons"
          src={currentVideo}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      </Modal>
    </>
  );
}

const styles = {
  companyname: {
    width: "80%",
    fontSize: "14px",
    margin: "auto 0",
  },
};

export default AnalystBriefing;
